import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DsFormFieldModule,
  DsSelectModule,
  ISizeInput,
  SelectListOption,
} from '@bmw-ds/components';
import { switchLanguage } from '../../state/current-user/current-user.actions';
import { FormsModule } from '@angular/forms';
import { SelectListSortPipe } from '../pipes/select-list-sort.pipe';
import { selectTranslationsKeys } from '../../admin/translations/state/translations.selectors';
import { selectUserState } from '../../state/current-user/current-user.selectors';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tqc-switch-language',
  imports: [DsFormFieldModule, DsSelectModule, FormsModule, SelectListSortPipe],
  templateUrl: './switch-language.component.html',
  standalone: true,
  styleUrl: './switch-language.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchLanguageComponent {
  private readonly store = inject(Store);
  public readonly translateService = inject(TranslateService);

  public readonly size = input<ISizeInput>('lg');

  private readonly userState = this.store.selectSignal(selectUserState);
  private readonly translationKeys = this.store.selectSignal(
    selectTranslationsKeys
  );

  public readonly currentUserActiveLanguage = computed(
    () => this.userState().user.language ?? ''
  );
  public readonly languageOptions = computed<SelectListOption[]>(() =>
    this.translationKeys().map((item): SelectListOption => ({
      id: item.toUpperCase(),
      label: item.toUpperCase(),
    }))
  );

  public onCurrentUserLanguageChange(selectedLanguage: unknown): void {
    const user = this.userState().user;
    if (!user.id || typeof selectedLanguage !== 'string') {
      return;
    }
    const languageKeyUpperCase = selectedLanguage.toUpperCase();

    this.store.dispatch(switchLanguage({ language: languageKeyUpperCase }));
  }
}
